import React, { useState, useEffect } from 'react'
import { Modal, Spin, Icon } from 'antd'
import { useTranslation } from 'react-i18next'
import PreviewAdModalHolder from '../../styles/previewAdModalStyle'
import { getSimilarAspectRatio } from '../../../../../services/display'

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp)$/i
const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)$/i
const AUDIO_EXT = /\.(mp3|wav|m4a|aac|ogg)$/i

const mediaKind = (ad) => {
  if (!ad) return 'unknown'
  const file = ad.file || ''
  if (ad.type === 'image' || IMAGE_EXT.test(file)) return 'image'
  if (ad.type === 'video' || VIDEO_EXT.test(file)) return 'video'
  if (ad.type === 'audio' || AUDIO_EXT.test(file)) return 'audio'
  return 'unknown'
}

// Full media preview for an ad (image / video / audio). Opened from the ad's
// thumbnail click or the "Preview" menu item — same modal for grid and list.
const PreviewAdModal = ({ visible, ad, onCancel }) => {
  const { t } = useTranslation()
  const [loaded, setLoaded] = useState(false)

  // Reset the spinner whenever a different ad is opened.
  useEffect(() => {
    if (visible) setLoaded(false)
  }, [visible, ad && ad.id])

  if (!ad) return null

  const kind = mediaKind(ad)
  const src = ad.file
  const showSpin = (kind === 'image' || kind === 'video') && !loaded

  return (
    <Modal title={t('Preview')} visible={visible} onCancel={onCancel} footer={null} width={800} destroyOnClose>
      <PreviewAdModalHolder>
        <div className="preview-stage">
          {kind === 'image' && (
            <img src={src} alt={ad.name} onLoad={() => setLoaded(true)} onError={() => setLoaded(true)} />
          )}
          {kind === 'video' && (
            <video
              src={src}
              controls
              autoPlay
              preload="metadata"
              onLoadedData={() => setLoaded(true)}
              onError={() => setLoaded(true)}
            />
          )}
          {kind === 'audio' && <audio src={src} controls autoPlay />}
          {kind === 'unknown' && (
            <div className="preview-unsupported">
              <Icon type="file-unknown" />
              <span>{t('Preview not available')}</span>
            </div>
          )}

          {showSpin && (
            <div className="preview-spin">
              <Spin size="large" />
            </div>
          )}
        </div>

        <div className="preview-meta">
          <span className="preview-name">{ad.name}</span>
          {ad.width && ad.height && (
            <span>
              {t('Resolution')}: {ad.width} x {ad.height}
            </span>
          )}
          {ad.width && ad.height && (
            <span>{getSimilarAspectRatio(ad.width, ad.height, t)}</span>
          )}
          {ad.date && (
            <span>
              {t('Creation date')}: {ad.date}
            </span>
          )}
        </div>
      </PreviewAdModalHolder>
    </Modal>
  )
}

export default PreviewAdModal
